import React from 'react';

import DashboardMobileView from './DashboardMobileView';
import DashboardDesktopView from './DashboardDesktop.view';
import { useWindowWidth } from 'shared-state/display-options/hooks';

const DashboardView: React.FC<any> = (props) => {
    const { smallDevice } = useWindowWidth();

    return smallDevice ? <DashboardMobileView {...props} /> : <DashboardDesktopView {...props} />;
};

export default DashboardView;
